
import Vue from 'vue';
import { UserModel } from '@descomplica/dex-models';
import { UnifiedCommentModel } from '../../models/UnifiedCommentModel';
import Comment from './Comment.vue';
import CommentInput from './CommentInput.vue';
import { FileModel } from '../../models/FileModel';

export default Vue.extend({
  components: {
    Comment,
    CommentInput,
  },
  props: {
    isSending: {
      type: Boolean,
      default: false,
    },
    isPastDue: {
      type: Boolean,
      default: false,
    },
    showScore: {
      type: Boolean,
      default: false,
    },
    showRepliesCount: {
      type: Boolean,
      default: true,
    },
    showFeedbackButton: {
      type: Boolean,
      default: true,
    },
    showLikeAndDislikeButtons: {
      type: Boolean,
      default: true,
    },
    comment: {
      type: Object as Vue.PropType<UnifiedCommentModel>,
      required: true,
    },
    user: {
      type: Object as Vue.PropType<UserModel>,
      required: true,
    },
    enableFileUpload: {
      type: Boolean,
      default: true,
    },
    enableCommentEdition: {
      type: Boolean,
      default: false,
    },
    remainingAttempts: {
      type: Number,
      default: null,
    },
    remainingAttemptsMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showReplies: false,
      isUpVotedComment: false as Boolean,
    };
  },
  methods: {
    onScoreChange(comment: UnifiedCommentModel) {
      this.$emit('onScoreChange', comment);
    },
    deleteComment(comment: UnifiedCommentModel) {
      this.$emit('deleteComment', comment);
    },
    deleteReply(reply: UnifiedCommentModel) {
      const { repliesId } = this.comment;
      const index = repliesId.indexOf(reply.id);
      if (index > -1) {
        repliesId.splice(index, 1);
      }

      this.deleteComment(reply);
    },
    onToggleReplies() {
      this.showReplies = !this.showReplies;
      this.$emit('onToggleReplies', this.showReplies);
    },
    onLikeClick(like: boolean) {
      this.$emit('onLikeClick', { comment: this.comment, like });
    },
    onDislikeClick(dislike: boolean) {
      this.$emit('onDislikeClick', { comment: this.comment, dislike });
    },
    onFeedbackClick() {
      this.$emit('onFeedbackClick');
    },
    onReplySubmit(params: { text: string; files: FileModel[] }) {
      const { text, files } = params;
      this.$emit('onReplySubmit', { comment: this.comment, text, files });
    },
    onCommentEdit(params: { text: string; files: FileModel[] }) {
      const { text, files } = params;
      this.$emit('onCommentEdit', { commentId: this.comment.id, text, files });
    },
  },
});
